module.exports = __webpack_public_path__ + "img/gd_black.ada79970.png";